import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClose"];
import * as React from 'react';
import ActionConfigCombinedHeaderContainer from 'automation-ui-action-features/components/ActionConfigCombinedHeaderContainer';
import ErrorMessage from 'automation-ui-canvas/components/errors/ErrorMessage';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorPanel = _ref => {
  let {
      onClose
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ActionConfigCombinedHeaderContainer, {
      children: onClose && /*#__PURE__*/_jsx(CloseButton, {
        onClick: onClose,
        insetBlockStart: "400",
        color: "icon-core-subtle"
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(PanelSection, {
        children: /*#__PURE__*/_jsx(ErrorMessage, Object.assign({}, rest))
      })
    })]
  });
};
export default ErrorPanel;